import { render, staticRenderFns } from "./MatAnswerProgress.vue?vue&type=template&id=d033d85e&scoped=true"
import script from "./MatAnswerProgress.vue?vue&type=script&lang=js"
export * from "./MatAnswerProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d033d85e",
  null
  
)

export default component.exports